import { render, staticRenderFns } from "./basepage.vue?vue&type=template&id=2d91dbf5&"
import script from "./basepage.vue?vue&type=script&lang=js&"
export * from "./basepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports